import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import './invite-and-earn.scss';
import Icon from 'components/mweb/Icon/Icon';
import { Link } from 'react-router-dom';
import { showLoginModal } from 'hb-redux-store/feature/modal/modal.action';
import { setAppNotification } from 'hb-redux-store/initial.action';
import { shareContent } from 'hb-redux-store/util/miscellaneousServices';
import history from 'hb-redux-store/history';
import { DEFAULT_REFERRAL_AMOUNT } from 'hb-redux-store/util/constantServices';

const InviteAndEarn = props => {
  const { redirectTo = '/my/vxl-point' } = props;
  let { iGet, orderConfirmation } = props;
  if (!iGet || iGet === 0) iGet = DEFAULT_REFERRAL_AMOUNT;
  const { area, addressLine2, referralActive, referralCode } = props.launchInfo,
    isLocationSelected = area && addressLine2,
    referralLink = `${window.location.origin}/invite/${referralCode}`;
  const getTextForSharing = () => {
    const header = '*Refer and earn:* Spread the word and keep earning.';
    const body = `Share this referral url with your near and dear ones. \n${referralLink}`;
    const footer = ``;
    const shareUrl = `${header}\n\n${body}\n${footer}`;
    return shareUrl;
  };
  const shareOnWhatsApp = () => {
    const shareUrl = getTextForSharing();
    // window.open(`whatsapp://send?text=${encodeURI(shareUrl)}`, '_blank');
    window.open(
      `https://api.whatsapp.com/send?text=${encodeURI(shareUrl)}`,
      '_blank'
    );
  };
  const shareSMS = () => {
    const shareUrl = getTextForSharing();
    window.open(`sms:;?body=${encodeURI(shareUrl)}`, '_blank');
  };
  const openShareIntent = () => {
    const url = referralLink;
    const text = getTextForSharing();
    const title = 'Refer and earn';
    shareContent({ url, text, title })
      .then(({ message = null }) => {
        if (message) props.setAppNotification(message);
      })
      .catch(({ message }) => {
        if (message) props.setAppNotification(message);
      });
  };
  const shareApps = [
    {
      icon: 'icon-referral-whatsapp',
      name: 'Whatsapp',
      onClick: shareOnWhatsApp,
    },
    {
      icon: 'icon-referral-fb-messenger',
      name: 'Messenger',
      onClick: openShareIntent,
    },
    { icon: 'icon-referral-sms', name: 'SMS', onClick: shareSMS },
    {
      icon: 'icon-referral-fb',
      name: 'facebook',
      onClick: openShareIntent,
    },
  ];

  const onSelect = app => {
    if (redirectTo === '/my/vxl-point') app.onClick();
    else {
      showLoginNotification();
    }
  };

  const showLoginNotification = () => {
    props.setAppNotification('Please login to access the referral link');
    setTimeout(() => {
      props.showLoginModal(true);
      history.replace(redirectTo);
    }, 1200);
  };
  return (
    <div
      className={`${
        !orderConfirmation ? 'desktop-invite' : 'desktop-invite-orderconfirm'
      }`}
    >
      <div className="desktop-invite--banner justify-content--space-between">
        <div className="flex-align-items-center">
          <Icon class="icon-order-box-coins flex-shrink-0" size={100} />
          <div className="desktop-invite--banner--content">
            {redirectTo === '/my/vxl-point' ? (
              <Link
                to={redirectTo}
                className="desktop-invite--banner--title flex-align-items-center"
              >
                <span>Refer & Earn</span>
              </Link>
            ) : (
              <div
                onClick={showLoginNotification}
                className="desktop-invite--banner--title flex-align-items-center cursor-hover"
              >
                <span>Refer & Earn</span>
              </div>
            )}
            <div className="desktop-invite--banner--description">
              Bring a friend to VegXL and get &#8377;{iGet} each, credited to
              both of you.
            </div>
            <div></div>
          </div>
        </div>

        {!orderConfirmation && (
          <Fragment>
            <div className="desktop-referral--share desktop-referral--share-home">
              <div className="desktop-referral--invite-title">
                Invite your friends with
              </div>
              <div className="desktop-referral--align-app ">
                {shareApps.map((app, index) => (
                  <div
                    className="app"
                    key={index}
                    onClick={() => onSelect(app)}
                  >
                    <Icon class={`app-icon ${app.icon}`} size={40} />
                    <div className="app-name">{app.name}</div>
                  </div>
                ))}
              </div>
            </div>
          </Fragment>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ initialReducer }) => {
  return {
    launchInfo: initialReducer.launchInfo,
  };
};

const mapDispatchToProps = {
  showLoginModal,
  setAppNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(InviteAndEarn);
